import { usePropertyContext } from 'context/propertyContext';
import { addDaysStr, dataDate, today } from 'features/dates/date-helpers';
import {
	type GetDailyRateRecsQuery,
	useGetDailyRateRecsQuery,
} from 'features/my-view/gql/_gen_/rec-review.gql';
import { useMemo } from 'react';
import { METRICS_DURATION } from '../helpers';

export type StrategyRates = Pick<
	NonNullable<NonNullable<GetDailyRateRecsQuery['getDailyRateRecs']>[number]>,
	'conservative_rate' | 'neutral_rate' | 'aggressive_rate'
>;

/**
 * Conservative / neutral / aggressive rates for every date in the home feed,
 * keyed by stay date. Fetched once for the whole feed range so day cards
 * don't each fire their own request.
 */
export const useStrategyRatesByDate = () => {
	const { property } = usePropertyContext();
	const propertyId = property?.propertyId;
	const startDate = today();

	const { data } = useGetDailyRateRecsQuery({
		skip: !propertyId,
		variables: {
			propertyId: propertyId!,
			startDate,
			endDate: addDaysStr(METRICS_DURATION - 1, startDate),
		},
	});

	return useMemo(() => {
		const ratesByDate = new Map<string, StrategyRates>();
		for (const rec of data?.getDailyRateRecs ?? []) {
			if (rec) ratesByDate.set(dataDate(rec.stay_date), rec);
		}
		return ratesByDate;
	}, [data]);
};
